import {
  Box,
  TextField,
  InputAdornment,
  Grid,
  FormControl,
  Button,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import React from "react";
import { sizes } from "../setupUtils";
import TransferList from "./TransferList";
import BasicModal from "./BasicModal";
import { useDispatch, useSelector } from "react-redux";
import { getProductGroups, setPGState } from "./productGroupSetupSlice";
import CollapseSection from "../../../components/ui/CollapseSection";
import SearchIcon from "@mui/icons-material/Search";

export default function SelectSKU() {
  const pgState = useSelector((store) => store.productGroupSetup);
  const { skus, selectedSKUs, countryID, searchedPGName } = pgState;
  const dispatch = useDispatch();

  function setSearchedPGName(event) {
    const name = event.target.value;
    dispatch(setPGState("searchedPGName", name));
  }

  function searchSKUs() {
    const productGroupName = searchedPGName;
    dispatch(getProductGroups({ countryID, productGroupName }));
  }

  return (
    <Box>
      <CollapseSection title="Select SKU to add">
        <Box
          sx={{
            mt: 3,
          }}
        >
          <Box sx={{ p: 1 }}>
            {/*Main Grid Container with two sections-filters on left and transferlist on right*/}
            <Grid container columns={10} spacing={2} rowGap={2}>
              {/*Left side form controls*/}
              <Grid item xs={10} lg={2}>
                <Box sx={{ mt: 1, ml: -1 }}>
                  <Grid container justifyContent="flex-end" spacing={2} pb={1}>
                    <Grid item sm={7.5} md={8.7} lg={11.5}>
                      <TextField
                        label="SKU"
                        variant="outlined"
                        onChange={setSearchedPGName}
                        value={searchedPGName}
                        InputProps={{ autoComplete: "off" }}
                      />
                    </Grid>

                    <Grid item xs={12} md={5.4} lg={11.5} sx={{ ml: 26 }}>
                      <Button
                        startIcon={<SearchIcon />}
                        sx={{
                          bgcolor: "darkBlue.light",
                          color: "white.main",
                          textTransform: "none",
                          "&:hover": {
                            bgcolor: "darkBlue.main",
                          },
                        }}
                        onClick={searchSKUs}
                      >
                        <Typography
                          sx={{ fontWeight: "bold", color: "white.main" }}
                        >
                          Search
                        </Typography>
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
              <Grid item sm={7} md={2.5} lg={8}>
                <Box
                  sx={{
                    mt: 1,
                    p: 4,
                    ml: 1,
                    mr: -2,
                    borderLeft: 1,
                    borderColor: "#c6c6c6",
                  }}
                >
                  <FormControl className={"fullHeight"}>
                    <TransferList
                      size="small"
                      leftList={skus}
                      rightList={selectedSKUs}
                      leftState={"skus"}
                      rightState={"selectedSKUs"}
                    />
                  </FormControl>
                  <BasicModal />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </CollapseSection>
    </Box>
  );
}
